import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
  return (
    <a
      href="whatsapp://send?phone=919324555493&text=Hi%20Sagar,%20I%20need%20help%20with%20financial%20planning."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105 whatsapp-pulse"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-5 h-5" fill="white" />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
}
